import {OperatingAreaEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Box, Modal, ModalProps} from "@mantine/core";
import {MouseEvent, useCallback} from "react";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {BaseOperatingAreaDataTable, BaseOperatingAreaDataTableProps} from "./BaseOperatingAreaDataTable";
import {useOperatingAreaAction} from "../../menu/OperatingAreaActionMenu/useOperatingAreaAction";

export type OperatingAreaDataTableProps = Omit<BaseOperatingAreaDataTableProps, 'renderActions'>

export const OperatingAreaDataTable = (props: OperatingAreaDataTableProps) => {
  const {
    ...rest
  } = props

  const {
    onOperatingAreaActionClick
  } = useOperatingAreaAction()

  const onEditActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: OperatingAreaEntity) => {
    e.stopPropagation()
    onOperatingAreaActionClick(record, 'EDIT')
  }, [onOperatingAreaActionClick])

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: OperatingAreaEntity) => {
    e.stopPropagation()
    onOperatingAreaActionClick(record, 'DELETE')
  }, [onOperatingAreaActionClick])

  const renderActions = useCallback((record: OperatingAreaEntity, index: number) => {
    return (
      <EntityActionGroup
        entity={record}
        permissionPrefix={"operatingarea"}
        edit={false}
        onEditActionClick={(e) => onEditActionClick(e, record)}
        onDeleteActionClick={(e) => onDeleteActionClick(e, record)}
      />
    )
  }, [onEditActionClick, onDeleteActionClick])

  return (
    <BaseOperatingAreaDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}

export type OperatingAreaDataTableModalProps = Omit<ModalProps, "onSubmit"> & {
  dataTable: Omit<OperatingAreaDataTableProps, 'recordsPerPageOptions'>
}

export const OperatingAreaDataTableModal = (props: OperatingAreaDataTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.entity.geofence.plural", "Operating  Areas"),
    dataTable,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <OperatingAreaDataTable
          {...dataTable}
          recordsPerPageOptions={[5]}/>
      </Box>
    </Modal>
  );
};
